import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;

  & > div {
    height: 100vh;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FormWrapper = styled.div`
  width: 100%;
  iframe {
    height: 480px;
  }
`;

export const Separator = styled.div`
  width: 80%;
  max-width: 500px;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.border.default};
  margin: ${({ theme }) => theme.spacing.unit * 4}px auto;
`;
